import {
  createContext,
  useCallback,
  useContext,
  useMemo,
  useState,
} from 'react';
import type { AuthProviderProps, AuthProviderType } from './types';

const Context = createContext({} as AuthProviderType);
const useAuthContext = (): AuthProviderType => useContext(Context);

const AuthProvider = ({ children }:AuthProviderProps) => {
  const userRolesFromLocalStorage = JSON.parse(localStorage.getItem('@UserRoles') || '[]');

  const [roles, setRoles] = useState<string[]>(userRolesFromLocalStorage);

  const checkIfHasRole = useCallback((role:string) => {
    return roles.includes(role);
  }, [roles]);

  const value = useMemo(() => ({
    roles,
    setRoles,
    checkIfHasRole,
  }), [checkIfHasRole, roles]);

  return (
    <Context.Provider value={value}>
      {children}
    </Context.Provider>
  );
};

export { AuthProvider, useAuthContext };
